import { generalStatusEnum } from './global.constants';

export enum customerActivityTypes {
	MONEY_ACTIVITIES = 'moneyActivities',
	CONTACTS = 'contacts',
	BENEFICIARIES = 'beneficiaries',
	BANK_ACCOUNTS = 'bankAccounts',
	SUPPORT_REQUESTS = 'supportRequests',
	ACCOUNTS_IN_PROCESS = 'accountsInProcess',
	WAITING_FOR_APPROVAL = 'waitingForApproval',
	ACCOUNTS_DECLINED = 'declinedAccounts',
}

export enum customerInitialAction {
	CLOSE_ACCOUNT = 'close-account',
	WITHDRAWL_ACCOUNT = 'withdrawl-account',
	SUPPORT_REQUESTS = 'support_requests',
}

export enum customerAccountDetailsTypes {
	PLAN = 'plan',
	PAYMENT = 'payment',
	BALANCE = 'balance',
	BALANCE_WITHDRAWAL = 'balanceWithdrawal',
	CONVERSION = 'conversion',
	BASIC_DATA = 'basicData',
	BENEFICIARIES = 'beneficiaries',
	BANK_ACCOUNTS = 'bankAccounts',
	CONTACTS = 'contacts',
	SUPPORT_REQUESTS = 'supportRequests',
	BALANCE_REFUND = 'balanceRefund',
}

export enum moneyActivityTypes {
	PAYMENT = 'Payment',
	BALANCE = 'Balance',
	CONVERSION = 'Conversion',
	CONVERSION_FEE = 'ConversionFee',
	PAYMENT_FEE = 'PaynentFee',
	BALANCE_REFUND = 'BalanceRefund',
}

export const beneficiaryStatusOptions = [
	{ value: generalStatusEnum.APPROVED, label: 'מאושר' },
	{ value: generalStatusEnum.APPROVEDWITHRISK, label: 'מאושר על תנאי' },
	{ value: generalStatusEnum.SUSPENDED, label: 'מושהה' },
];

export enum BankAccountStatus {
	None = 'None',
	Pending = 'Pending',
	PendingSigning = 'PendingSigning',
	Completed = 'Completed',
	Rejected = 'Rejected',
	Failed = 'Failed',
	Deleted = 'Deleted',
	Approved = 'Approved',
}

export const bankAccountStatusOptions = [
	{ value: generalStatusEnum.COMPLETED, label: 'מאושר' },
	{ value: generalStatusEnum.REJECTED, label: 'לא מאושר' },
];

export enum withdrawalBalanceSteps {
	WITHDRAWAL_INITIAL_REQUEST = 'withdrawalInitialRequest',
	WITHDRAWAL_ALTSHULER_CC_TO_BANK_ACCOUNT = 'withdrawalAltshulerCCToBankAccount',
	WITHDRAWAL_ALTSHULER_TO_CUSTOMER_BANK_ACCOUNT = 'withdrawalAltshulerToCustomerBankAccount',
}

export enum relationsTypes {
	MANAGER = 'altshulerManagers',
	DEALER = 'altshulerDealers',
	AGENT = 'altshulerAgents',
	LEAD = 'altshulerLeads',
}

export enum tableFileType {
	TRANSACTIONS = 'transactions',
}
